// components/Modals/UploadConfirmationModal.jsx
import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const UploadConfirmationModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: 4,
          borderRadius: 2,
          width: 400,
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" gutterBottom>
          File Processing Started!
        </Typography>
        <Typography sx={{ mb: 2 }}>
          An email will be sent to you with the details of the uploaded file
          after it is processed.
        </Typography>

        <Box display="flex" justifyContent="flex-end" style={{ gap: "10px" }}>
          <Button
            variant="contained"
            color="primary"
            style={{ color: "white" }}
            onClick={() => navigate("/files")}
          >
            Go to Files Tab
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ color: "white" }}
            onClick={onClose}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UploadConfirmationModal;
